<template>
  <div class="page-card">
    <h2 class="page-title">系统通知发送</h2>

    <el-form ref="formRef" :model="form" :rules="rules" label-width="120px" class="send-form">
      <el-form-item label="任务名称" prop="taskName">
        <el-input v-model="form.taskName" maxlength="80" show-word-limit placeholder="请输入任务名称" />
      </el-form-item>
      <el-form-item label="发送对象" prop="receiverType">
        <el-radio-group v-model="form.receiverType">
          <el-radio-button :label="1">艺人</el-radio-button>
          <el-radio-button :label="2">商家</el-radio-button>
          <el-radio-button :label="3">全部</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发送范围" prop="sendScopeType">
        <el-radio-group v-model="form.sendScopeType">
          <el-radio-button :label="1">全量立即发送</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="通知分类" prop="bizType">
        <el-select v-model="form.bizType" style="width: 220px">
          <el-option label="系统通知" :value="6" />
        </el-select>
      </el-form-item>
      <el-form-item label="通知标题" prop="messageTitle">
        <el-input v-model="form.messageTitle" maxlength="120" show-word-limit placeholder="请输入通知标题" />
      </el-form-item>
      <el-form-item label="通知正文" prop="messageContent">
        <el-input
          v-model="form.messageContent"
          type="textarea"
          :rows="8"
          maxlength="1000"
          show-word-limit
          placeholder="请输入站内通知内容"
        />
      </el-form-item>
      <el-form-item label="筛选条件快照">
        <el-input :value="form.filterJson" readonly />
        <div class="helper-text">V1 仅支持全量发送，筛选条件能力保留到下一阶段。</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="submitting" @click="submitForm">立即发送</el-button>
        <el-button @click="resetForm">重置</el-button>
        <el-button type="text" @click="$router.push('/ops/message-tasks')">查看发送任务记录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { createAdminMessageTask } from '../../../api/opsMessage'

function getDefaultForm() {
  return {
    taskName: '',
    receiverType: 3,
    sendScopeType: 1,
    filterJson: '{}',
    bizType: 6,
    messageTitle: '',
    messageContent: ''
  }
}

export default {
  name: 'OpsMessageSendPage',
  data() {
    return {
      form: getDefaultForm(),
      submitting: false,
      rules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        receiverType: [{ required: true, message: '请选择发送对象', trigger: 'change' }],
        sendScopeType: [{ required: true, message: '请选择发送范围', trigger: 'change' }],
        bizType: [{ required: true, message: '请选择通知分类', trigger: 'change' }],
        messageTitle: [{ required: true, message: '请输入通知标题', trigger: 'blur' }],
        messageContent: [{ required: true, message: '请输入通知正文', trigger: 'blur' }]
      }
    }
  },
  methods: {
    resetForm() {
      this.form = getDefaultForm()
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) {
          return
        }
        this.submitting = true
        try {
          await createAdminMessageTask(this.form)
          this.$message.success('系统通知任务已创建')
          this.$router.push('/ops/message-tasks')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.send-form {
  max-width: 900px;
}

.helper-text {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}
</style>

